// åæ­¥èª 'rmc-calendar/lib/locale/en_US';

export default {
  title: 'Kalender',
  today: 'I dag',
  month: 'MÃ¥ned',
  year: 'Ãr',
  am: 'AM',
  pm: 'PM',
  dateTimeFormat: 'dd/MM/yyyy w hh:mm',
  dateFormat: 'dd/MM/yyyy w',
  noChoose: 'Intet valgt',
  week: ['SÃ¸n', 'Man', 'Tir', 'Ons', 'Tor', 'Fre', 'LÃ¸r'],
  clear: 'Fjern',
  selectTime: 'VÃ¦lg tidspunkt',
  selectStartTime: 'VÃ¦lg starttidspunkt',
  selectEndTime: 'VÃ¦lg sluttidspunkt',
  start: 'Start',
  end: 'Slut',
  begin: 'Start',
  over: 'Slut',
  begin_over: 'Start/Stop',
  confirm: 'BekrÃ¦ft',
  monthTitle: 'MM yyyy',
  loadPrevMonth: 'IndlÃ¦s forrige mÃ¥ned',
  yesterday: 'I gÃ¥r',
  lastWeek: 'Sidste uge',
  lastMonth: 'Sidste mÃ¥ned'
};
